import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ComissaoJulgadoraRoutingModule } from './comissao-julgadora-routing.module'
import { CadastrarExaminadorUnicampComponent } from './cadastrar-examinador-unicamp/cadastrar-examinador-unicamp.component'
import { MatCardModule } from '@angular/material/card'
import { ReactiveFormsModule } from '@angular/forms'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatOptionModule } from '@angular/material/core'
import { MatSelectModule } from '@angular/material/select'
import { MatInputModule } from '@angular/material/input'
import { FlexLayoutModule } from '@ngbracket/ngx-layout'
import { MatIconModule } from '@angular/material/icon'
import { MatButtonModule } from '@angular/material/button'
import { MatDialogModule } from '@angular/material/dialog'
import { CadastrarExaminadorExternoComponent } from './cadastrar-examinador-externo/cadastrar-examinador-externo.component'
import { ListaConcursoExaminadorComponent } from './lista-concurso-examinador/lista-concurso-examinador.component'
import { ListaProvaExaminadorComponent } from './lista-prova-examinador/lista-prova-examinador.component'
import { ListaClassificacaoExaminadorComponent } from './lista-classificacao-examinador/lista-classificacao-examinador.component'
import { ListaClassificacaoPresidenteComponent } from './lista-classificacao-presidente/lista-classificacao-presidente.component'
import { ReporteJustificativaDialogComponent } from './reporte-justificativa-dialog/reporte-justificativa-dialog.component'
import { ReporteHistoricoDialogComponent } from './reporte-historico-dialog/reporte-historico-dialog.component'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatTooltipModule } from '@angular/material/tooltip'
import { NgxMaskDirective, NgxMaskPipe } from 'ngx-mask'
import { MatCheckboxModule } from '@angular/material/checkbox'
import { MatMenuModule } from '@angular/material/menu'
import { MatTableModule } from '@angular/material/table'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatStepperModule } from '@angular/material/stepper'
import { ListaNotaExaminadorComponent } from './lista-nota-examinador/lista-nota-examinador.component'
import { TableProvasAtivasExaminadorComponent } from './table-provas-ativas-examinador/table-provas-ativas-examinador.component'
import { ConceitoJustificativaDialogComponent } from './lista-classificacao-examinador/justificativa-dialog/conceito-justificativa-dialog.component'
import { JustificativaInfoDialogComponent } from './lista-classificacao-examinador/justificativa-info-dialog/justificativa-info-dialog.component'

import { FormsModule } from '@angular/forms'
import { ListagemExaminadoresIconeNotificarComponent } from './listagem-examinadores-icone-notificar/listagem-examinadores-icone-notificar.component'
import { AutocompleteKeyValueComponent } from './autocomplete-key-value/autocomplete-key-value.component'
import {
  ListagemExaminadoresComponent,
  NotificarDialogComponent,
  EditarEmailDialogComponent,
} from './listagem-examinadores/listagem-examinadores.component'
import { ListagemExaminadoresFiltroComponent } from './listagem-examinadores-filtro/listagem-examinadores-filtro.component'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { RegistarDeAcordoExaminadorComponent } from './registar-de-acordo-examinador/registar-de-acordo-examinador.component'
import { MatBadgeModule } from '@angular/material/badge'
import { TermoRegistrarDeAcordoDialogComponent } from './termo-registrar-de-acordo-dialog/termo-registrar-de-acordo-dialog.component'
import { DeclarationComponent } from './declaration/declaration.component'
import { MatRadioModule } from '@angular/material/radio'
import { TransferirPresidenciaDialogComponent } from './transferir-presidencia-dialog/transferir-presidencia-dialog.component'
import { SubstituirSuplenteDialogComponent } from './substituir-suplente-dialog/substituir-suplente-dialog.component'
import { AcordoDocumentStepperDialogComponent } from './acordo-document-stepper-dialog/acordo-document-stepper-dialog.component'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { PdfViewerModule } from '../pdf-viewer/pdf-viewer.module'
import { EllipsisTooltipComponent } from '../components/ellipsis-tooltip-simple/ellipsis-tooltip-simple.component'
import { VisualizarComplementosComponent } from './visualizar-complementos/visualizar-complementos.component'
import { DefaultPaginatorComponent, PageHeaderComponent, SearchInputComponent, TableNoDataComponent, ExportButtonComponent, BackButtonComponent, CancelButtonComponent } from '../shared';
import { InputNotaAvaliacaoComponent } from './input-nota-avaliacao/input-nota-avaliacao.component'
import { ArquivoViewerAvaliacaoComponent } from './arquivo-viewer-avaliacao/arquivo-viewer-avaliacao.component'
import { VisualizarClassificacaoFase1Component } from './visualizar-classificacao-fase1/visualizar-classificacao-fase1.component'
import { ModalPendenciasClassificacaoComponent } from './modal-pendencias-classificacao/modal-pendencias-classificacao.component'
import { ModalPendenciasProvaAndamentoComponent } from './modal-pendencias-prova-andamento/modal-pendencias-prova-andamento.component'

@NgModule({
  declarations: [
    CadastrarExaminadorExternoComponent,
    CadastrarExaminadorUnicampComponent,
    ListaConcursoExaminadorComponent,
    ListaNotaExaminadorComponent,
    ListaProvaExaminadorComponent,
    ListagemExaminadoresComponent,
    ListagemExaminadoresFiltroComponent,
    AutocompleteKeyValueComponent,
    ListagemExaminadoresIconeNotificarComponent,
    ListaNotaExaminadorComponent,
    TableProvasAtivasExaminadorComponent,
    ListaClassificacaoExaminadorComponent,
    ConceitoJustificativaDialogComponent,
    JustificativaInfoDialogComponent,
    RegistarDeAcordoExaminadorComponent,
    NotificarDialogComponent,
    EditarEmailDialogComponent,
    ListaClassificacaoPresidenteComponent,
    ReporteJustificativaDialogComponent,
    ReporteHistoricoDialogComponent,
    TermoRegistrarDeAcordoDialogComponent,
    DeclarationComponent,
    TransferirPresidenciaDialogComponent,
    SubstituirSuplenteDialogComponent,
    AcordoDocumentStepperDialogComponent,
    VisualizarComplementosComponent,
    InputNotaAvaliacaoComponent,
    ArquivoViewerAvaliacaoComponent,
    VisualizarClassificacaoFase1Component,
    ModalPendenciasClassificacaoComponent,
    ModalPendenciasProvaAndamentoComponent,
  ],
  imports: [
    CommonModule,
    ComissaoJulgadoraRoutingModule,
    FlexLayoutModule,
    FormsModule,
    MatButtonModule,
    MatCardModule,
    MatCheckboxModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatOptionModule,
    MatPaginatorModule,
    MatSelectModule,
    MatTableModule,
    MatTooltipModule,
    MatAutocompleteModule,
    NgxMaskDirective,
    NgxMaskPipe,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatMenuModule,
    MatTableModule,
    MatPaginatorModule,
    MatDialogModule,
    MatBadgeModule,
    MatDialogModule,
    MatRadioModule,
    MatStepperModule,
    MatProgressSpinnerModule,
    MatProgressBarModule,
    PdfViewerModule,
    EllipsisTooltipComponent,
    DefaultPaginatorComponent,
    PageHeaderComponent,
    SearchInputComponent,
    TableNoDataComponent,
    ExportButtonComponent,
    BackButtonComponent,
    CancelButtonComponent,
  ],
  exports: [
    ArquivoViewerAvaliacaoComponent,
    ReporteHistoricoDialogComponent,
  ],
})
export class ComissaoJulgadoraModule {}
